import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categoryMap } from '@/mocks/categories';
import ArticleCard from '@/components/base/ArticleCard';

const featuredImageUrls: Record<string, string> = {
  'anwang91-latest-access-address': 'https://readdy.ai/api/search-image?query=A%20dark%20digital%20tunnel%20with%20glowing%20onion%20layers%20representing%20Tor%20network%20encryption%2C%20abstract%20cybersecurity%20concept%2C%20warm%20amber%20and%20dark%20tones%2C%20minimalist%20digital%20art%20style&width=800&height=400&seq=article-1&orientation=landscape',
  'tor-browser-install-guide': 'https://readdy.ai/api/search-image?query=A%20clean%20minimalist%20digital%20workspace%20showing%20Tor%20browser%20interface%20concept%2C%20soft%20green%20and%20warm%20lighting%2C%20modern%20tech%20aesthetic%2C%20abstract%20privacy%20protection%20theme&width=800&height=400&seq=article-2&orientation=landscape',
  'anwang91-registration-guide': 'https://readdy.ai/api/search-image?query=An%20abstract%20digital%20registration%20interface%20with%20lock%20icons%20and%20shield%20symbols%2C%20warm%20amber%20accents%20on%20dark%20background%2C%20cybersecurity%20aesthetic%2C%20clean%20modern%20design&width=800&height=400&seq=article-3&orientation=landscape',
  'darknet-trading-security': 'https://readdy.ai/api/search-image?query=Abstract%20digital%20transaction%20security%20concept%20with%20shield%20and%20crypto%20symbols%2C%20warm%20green%20and%20amber%20tones%2C%20modern%20minimalist%20financial%20security%20design&width=800&height=400&seq=article-4&orientation=landscape',
  'identify-darknet-scams': 'https://readdy.ai/api/search-image?query=A%20warning%20sign%20concept%20with%20digital%20phishing%20hook%20and%20shield%2C%20warm%20red%20and%20amber%20accents%2C%20cybersecurity%20awareness%20design%2C%20clean%20minimalist%20style&width=800&height=400&seq=article-5&orientation=landscape',
  'darknet-malware-defense': 'https://readdy.ai/api/search-image?query=Digital%20virus%20defense%20concept%20with%20shield%20blocking%20malicious%20code%2C%20warm%20green%20glow%2C%20cybersecurity%20protection%20aesthetic%2C%20modern%20minimalist%20tech%20design&width=800&height=400&seq=article-6&orientation=landscape',
};

export default function FeaturedArticles() {
  const featured = articles.slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            精选文章
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            由暗网91安全团队精心编撰的深度内容，涵盖访问教程、安全指南、隐私保护等多个领域
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((article) => {
            const cat = categoryMap[article.category];
            return (
              <ArticleCard
                key={article.id}
                slug={article.slug}
                title={article.title}
                excerpt={article.excerpt}
                category={article.category}
                categoryName={cat?.name || article.category}
                author={article.author}
                publishDate={article.publishDate}
                readTime={article.readTime}
                imageUrl={featuredImageUrls[article.slug] || ''}
                tags={article.tags}
              />
            );
          })}
        </div>
        <div className="text-center mt-8">
          <Link
            to="/category/access-tutorial"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-secondary-100 text-secondary-800 font-medium rounded-md hover:bg-secondary-200 transition-colors duration-200 text-sm whitespace-nowrap"
          >
            查看全部文章
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}